module.exports = {
  environment: 'development'
};
